export interface IGroupProps {
  readonly group: string
  readonly course: string
  readonly cycle: string
  readonly grade: string
}

